import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { isPartner } from '@app/helpers/mode.helpers';
import { ServiceConfigService } from '@app/services/service-config.service';
import { TranslateService } from '@ngx-translate/core';
declare let gtag: Function;

@Component({
    selector: 'nh-status-dashboard',
    templateUrl: './status-dashboard.component.html',
    styleUrls: ['./status-dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class StatusDashboardComponent implements OnInit {

  appealStatusTrackerSwitch: boolean = false;
  currentLang: string;
  globalLang: string;
  isPartner: boolean = false;

  constructor(private serverConfig: ServiceConfigService, public translateService: TranslateService) { }

  ngOnInit(): void {
    this.appealStatusTrackerSwitch = this.serverConfig.getServerConfig()?.appealStatusTrackerSwitch;
    const userType = sessionStorage.getItem('userType');
    this.isPartner = isPartner(userType);
    this.currentLang = sessionStorage.getItem('currentLang');
    this.globalLang = sessionStorage.getItem('globalTranslatedLan');
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.currentLang = res.lang;
    });
  }

  trackAppealsTabClick(): void {
    gtag('event', 'appeals_tracker_tab_click', {
      'event_category': 'appeals_tracker_tab_click',
      'event_label': 'appeals_tracker_tab_click',
    });
  }
}
